import { render, staticRenderFns } from "./DefaultValueInput.vue?vue&type=template&id=1910f9e8"
import script from "./DefaultValueInput.vue?vue&type=script&lang=js"
export * from "./DefaultValueInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports